import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { OrgInitService } from './org-init.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrgInitGuard implements CanActivate {
  private initialized = false;
  private initPromise: Promise<boolean | UrlTree> | null = null;

  constructor(
    private orgInitService: OrgInitService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean {
    console.log('[OrgInitGuard] canActivate called for route:', state.url);
    debugger
    // Only initialize once
    if (!this.initialized) {
      if (!this.initPromise) {
        this.initPromise = this.performInitialization();
      }
      //return this.initPromise.then(() => {
      //  console.log('[OrgInitGuard] Initialization complete, allowing navigation');
      //  return true;
      //});
      return this.initPromise;
    }

    return true;
  }

  private performInitialization(): Promise<boolean | UrlTree> {
    return new Promise((resolve) => {
      console.log('[OrgInitGuard] Starting organization validation...');

      this.orgInitService.initializeOrgValidation().subscribe({
        next: (result) => {
          console.log('[OrgInitGuard] Org validation result:', result);
          this.initialized = true;

          if (result.success) {
            console.log('[OrgInitGuard] Organization validated');
            resolve(true);
          } else {
            console.log('[OrgInitGuard] Redirecting to org-input');
            resolve(this.router.createUrlTree(['/org-input']));
          }
        },
        error: (error) => {
          console.error('[OrgInitGuard] Error:', error);
          this.initialized = true;
          resolve(this.router.createUrlTree(['/org-input']));
        }
      });
    });
  }
}
